import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {ApplicationInfoPage} from './application-info';

const routes: Routes = [
  { path: '', component: ApplicationInfoPage },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ApplicationInfoPageRoutingModule {}
